import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import History from "./Components/About/History/history";
import { Navigate } from "react-router-dom";
import Board from "./Components/About/Leadership/Board/board";
import Educators from "./Components/About/Leadership/Educators/Educators";
import Fellows from "./Components/About/Leadership/Fellows/Fellows";
import Leadership from "./Components/About/Leadership/Leadership";
import Staff from "./Components/About/Leadership/Staff/Staff";
import CodeOfConduct from "./Components/About/Mission/CodeOfConduct";
import Mission from "./Components/About/Mission/Mission";
import Newsletter from "./Components/About/Newsletter/Newsletter";
import Academics from "./Components/Academics/Academics";
import Admission from "./Components/Admission/Admission";
import Alumni from "./Components/Alumni";
import Application from "./Components/Application/Application";
import Approach from "./Components/Approach";
import BeingAVolunteer from "./Components/BeingAVolunteer/BeingAVolunteer";
import CampusAndCulture from "./Components/CampusAndCulture";
import Career from "./Components/Career/index";
import ClubAndCommitee from "./Components/ClubAndCommitee";
import ContactUs from "./Components/ContactUs";
import DesignPage from "./Components/Design/d_home";
import IndiDesignpage from "./Components/Design/d_home2";
import DesignList from "./Components/Design/d_project";
import Guideline from "./Components/Design/guideline";
import DigitalTool from "./Components/DigitalTool";
import Donate from "./Components/Donate/Donate";
import Education from "./Components/Education";
import Employment from "./Components/Employment";
import Environemnt from "./Components/Environment";
import Faqs from "./Components/Faqs";
import Fellowship from "./Components/Fellowship/Fellowship";
import Financials from "./Components/Financial/Financial";
import Publications from "./Components/Financial/Publications/Publications";
import Health from "./Components/Health";
import Home from "./Components/Home/index";
import HowTo from "./Components/HowTo/HowTo";
import Impact from "./Components/Impact/Impact";
import Information from "./Components/Information";
import Kith from "./Components/Kith/Kith";
import Carek from "./Components/Kith/KithComp/careerkith/careerk";
import KithFaq from "./Components/Kith/KithComp/faqkith/faqk";
import KithFinancials from "./Components/KithFinancials";
import KithLeadership from "./Components/KithLeadership";
import LifeAtSchool from "./Components/LifeAtSchool/LifeAtSchool";
import Livelihood from "./Components/Livelihood";
import MakeAGift from "./Components/MakeAGift/MakeAGift";
import Moonshots from "./Components/Moonshots/Moonshots";
import OnlineEnrollment from "./Components/OnlineEnrollment/OnlineEnrollment";
import OurRole from "./Components/OurRole";
import OurSupporter from "./Components/OurSupporter";
import PodCasts from "./Components/Podcasts";
import SafetyAndWellBeing from "./Components/SafetyAndWellBeing";
import ScrollToTop from "./Components/ScrollToTop";
import Sidemap from "./Components/Sitemap/Sidemap";
import Subscribebtn from "./Components/SubscribeButton/Subscribebtn";
import WaysToGive from "./Components/WaysToGive/WaysToGive";
import WhyDonate from "./Components/WhyDonate/WhyDonate";
import WriteToUs from "./Components/WriteToUs";
import "./styles.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/">
        <ScrollToTop />
        <ToastContainer position="top-right" autoClose={3000} />
        <Routes>
          <Route path="/sitemap" element={<Sidemap />}></Route>
          <Route path="/kith/career" element={<Carek />}></Route>
          <Route path="/kith/career" element={<Carek />}></Route>
          <Route path="/kith/faqs" element={<KithFaq />}></Route>
          <Route path="/" element={<Home />}></Route>
          <Route path="/about" element={<OurRole />}></Route>
          <Route path="/leadership" element={<Leadership />}></Route>
          <Route path="/career" element={<Career />}></Route>
          <Route path="/board" element={<Board />}></Route>
          <Route path="/staff" element={<Staff />}></Route>
          <Route path="/educators" element={<Educators />}></Route>
          <Route path="/fellows" element={<Fellows />}></Route>
          <Route path="/fellowship" element={<Fellowship />}></Route>
          <Route path="/our-role" element={<Navigate to="/about" replace />}></Route>
          <Route path="/health" element={<Health />}></Route>
          <Route path="/financials" element={<Financials />}></Route>
          <Route path="/faqs" element={<Faqs />}></Route>
          <Route path="/publications" element={<Publications />}></Route>
          <Route path="/application" element={<Application />}></Route>

          <Route path="/newsletter" element={<Newsletter />}></Route>
          <Route path="/mission" element={<Mission />}></Route>
          <Route path="/history" element={<History />}></Route>
          <Route path="/code-of-conduct" element={<CodeOfConduct />}></Route>

          <Route path="/design" element={<DesignPage />}></Route>
          <Route path="/designlist" element={<DesignList />}></Route>
          <Route path="/designindividual" element={<IndiDesignpage />}></Route>
          <Route path="/guideline" element={<Guideline />}></Route>

          <Route path="/approach" element={<Approach />}></Route>
          <Route path="/digital-tool" element={<DigitalTool />}></Route>
          <Route path="/impact" element={<Impact />}></Route>
          <Route path="/environment" element={<Environemnt />}></Route>
          <Route path="/livelihood" element={<Livelihood />}></Route>
          <Route path="/moonshots" element={<Moonshots />}></Route>
          <Route path="/make-a-gift" element={<MakeAGift />}></Route>
          <Route path="/ways-to-give" element={<WaysToGive />}></Route>
          <Route path="/education" element={<Education />}></Route>
          <Route path="/donate" element={<Donate />}></Route>
          <Route path="/why-donate" element={<WhyDonate />}></Route>
          <Route
            path="/being-a-volunteer"
            element={<BeingAVolunteer />}
          ></Route>
          <Route path="/podcasts" element={<PodCasts />}></Route>
          <Route path="/contact-us" element={<ContactUs />}></Route>
          <Route path="/contact-us/write-to-us" element={<WriteToUs />}></Route>
          <Route path="/our-supporter" element={<OurSupporter />}></Route>
          <Route path="/kith/enrollment" element={<OnlineEnrollment />}></Route>
          <Route path="/kith/how-to" element={<HowTo />}></Route>
          <Route path="/kith/overview" element={<Kith />}></Route>
          <Route path="/kith/admission" element={<Admission />}></Route>
          <Route path="/kith/life-at-school" element={<LifeAtSchool />}></Route>
          <Route path="/kith/academics" element={<Academics />}></Route>
          <Route
            path="/kith/campus-and-culture"
            element={<CampusAndCulture />}
          ></Route>
          <Route
            path="/kith/safety-and-wellbeing"
            element={<SafetyAndWellBeing />}
          ></Route>
          <Route
            path="/kith/club-and-commitee"
            element={<ClubAndCommitee />}
          ></Route>
          <Route path="/kith/information" element={<Information />}></Route>
          <Route path="/kith/alumni" element={<Alumni />}></Route>
          <Route path="/kith/leadership" element={<KithLeadership />}></Route>
          <Route path="/kith/employment" element={<Employment />}></Route>
          <Route path="/kith/financials" element={<KithFinancials />}></Route>
          {/* <Route path="/kith/career" element={<KithCareer />}></Route> */}
        </Routes>

        <Subscribebtn />
      </BrowserRouter>
    </div>
  );
}

export default App;
